import { render } from "./Navigation.vue?vue&type=template&id=768f9a1b&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=768f9a1b&scoped=true&lang=css"

import exportComponent from "/Users/vaninamikova/Documents/Learning/Old Projects/tab-tracker/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768f9a1b"]])

export default __exports__